// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3a3z3","calendarButtons":"ClockData_calendarButtons__2sNLc"};